import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { RequestAction } from '../../modules/shared/components/member-view/actions';
import { insuranceQuestionnaire_ShowQuestionnaire } from 'src/app/modules/shared/components/insurance-questionnaire/selectors';
import { insuranceDetails_Model } from 'src/app/modules/shared/components/insurance-details/selectors';

@Component({
  selector: 'app-member-statements-view',
  templateUrl: './member-statements-view.component.html',
  styleUrls: ['./member-statements-view.component.scss'],
  host: {
    class: 'w-100'
  }
})
export class MemberStatementsViewComponent extends ComponentBase implements OnInit, OnDestroy {

  constructor(public store: Store<AppState>) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

}
